import { ImageNode, MetafieldNode } from '../types';

export const PRODUCTS_QUERY = `
  query Products($ids: [ID!]!) {
    nodes (ids: $ids) {
      ... on Product {
        id,
        handle,
        variants(first: 1) {
          nodes {
            id
            price {
              amount
            },
            sku,
            weight
          }
        },
        images(first: 20) {
          nodes {
            url
          }
        },
        metafields(identifiers: [
          { namespace: "ingredient_item", key: "ingredient_page" }
          { namespace: "ingredient_item", key: "new_ingredient_page" }
          { namespace: "my_account", key: "set_items" },
          { namespace: "my_account", key: "special_msg" },
          { namespace: "my_account", key: "discount_rate" },
          { namespace: "my_account", key: "title" },
          { namespace: "my_account", key: "display_unit" },
          { namespace: "qty", key: "max_value" },
          { namespace: "qty", key: "min_value" },
          { namespace: "qty", key: "step" },
        ]) {
          namespace
          key
          value
        }
      }
    }
  }
`;

export type ProductsQueryVariants = {
  ids: string[];
};

export type ProductsQueryResponse = {
  nodes: (ProductNode | null)[];
};

type ProductNode = {
  id: string;
  handle: string;

  variants: {
    nodes: VariantNode[];
  };

  images: {
    nodes: ImageNode[];
  };

  metafields: MetafieldNode[];
};

type VariantNode = {
  id: string;
  price: {
    amount: string; // stringで返る
  };
  sku: string | null;
  weight: number | null;
};
